module.exports = function getResource(label, vars = []) {
    const resources = {
        editProfileInfo: 'Edit Profile Information',
        save: 'Save',
        savedMessage: 'Your changes have been saved.'
    };
    return resources[label];
};
